<template>
    <div class="module2">
        <img src="../../../assets/image/m2_img1.png" alt="示例图" />
        <img src="../../../assets/image/m2_img2.png" alt="示例图" />
        <img src="../../../assets/image/m2_img3.png" alt="示例图" />
        <img src="../../../assets/image/m2_img4.png" alt="示例图" />
        <img src="../../../assets/image/m2_img5.png" alt="示例图" />
    </div>
</template>

<style lang="scss" scoped>
.module2{
    img{
        width: 100%;
    }
}
</style>